import { render, staticRenderFns } from "./view-file.vue?vue&type=template&id=653bd930&scoped=true&"
import script from "./view-file.vue?vue&type=script&lang=js&"
export * from "./view-file.vue?vue&type=script&lang=js&"
import style0 from "./view-file.vue?vue&type=style&index=0&id=653bd930&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653bd930",
  null
  
)

export default component.exports